export default {
  name: 'SettingsThemeImage',
  props: {
    dark: {
      type: Boolean,
      default: false
    },
    showTransparencyGrid: {
      type: Boolean,
      default: false
    },
    imgSrc: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      lightIconBg: '#00000066',
      darkIconBg: '#FFFFFF66'
    };
  },
  methods: {
    getAspectRatio(width, height) {
      const factor = width / height;
      const threshold = 0.2;
      if (factor < 1 - threshold) {
        return 'portrait';
      } else if (factor > 1 + threshold) {
        return 'landscape';
      }
      return 'square';
    },
    handleImageAdded(event) {
      var input = event.target;
      if (input.files && input.files[0]) {
        this.updateImageThumbnail(input.files[0]);
      }
    },
    addImage() {
      this.$refs['fileInput'].click();
    },
    resetThumbnail() {
      this.$refs['imageElement'].src = this.imgSrc;
    },
    updateImageThumbnail(file) {
      var reader = new FileReader();
      const imageRef = this.$refs['imageElement'];
      reader.onload = e => {
        imageRef.src = e.target.result;
        // NOTE: move to img.onLoad ?
        // have to wait for image loaded into img element to get current width & height
        this.$nextTick(() => {
          const orientation = this.getAspectRatio(imageRef.width, imageRef.height);
          this.$emit('image:update', file, orientation);
        });
      };
      reader.readAsDataURL(file);
    }
  }
};